window.addEventListener('load', (event) => {
  // Sets the phone icon on the header to green (within business hours)
  const phoneIcon 			= document.querySelector('.site-header-phone--button svg');
  const businessHourStart 	= 7; // 8AM PST (time function is 0-based) //7AM during daylight savings time
  const businessHourEnd   	= 15; // open until 4:59pm -> 16:59 // 15 during daylight savings time
  const timeOffset			= -8; // PST is 8 hours behind UTC
  const currentHour			= new Date().getUTCHours() + timeOffset;
  if ( phoneIcon
      && currentHour >= businessHourStart
      && currentHour <= businessHourEnd
      || currentHour == -8){
  //   phoneIcon.classList.add('phone-icon--on');
    phoneIcon.style.fill = "#01b91b";
    phoneIcon.parentElement.setAttribute('title', "Call Us, We're Open!");
    //console.log(phoneIcon, currentHour, businessHourStart, businessHourEnd);
  }
  
  // Run only on devices 480px wide or smaller
  let mql = window.matchMedia('(max-width: 480px)');
  if(mql.matches){
    
    let searchBar 				= null;
    let searchBarInput			= null;
    let site_header_main 		= null;  
    const hamburgerMenuIcon		= document.querySelector('.site-header-menu-toggle');
    const mobileLogo			= document.querySelector('.site-header-logo');
    const phoneIcon				= document.querySelector('.site-header-phone');
    const cartIcon				= document.querySelector('.site-header-cart');
    const static_header 		= document.getElementById('shopify-section-static-header');
    let   lastScrollTop			= 0;
    const customerAccountLinks	= document.querySelector('[data="customerAccountLinks"]');
    const customerCareUL		= document.querySelector('.navmenu-id-customer-care > .navmenu');
    const site_header       = document.querySelector('.site-header');
    let search_bar_close  = null;
    let is_close_icon_init = false;
    
    // Move cusomer account links to inside Customer Care submenu
    customerCareUL.insertBefore(customerAccountLinks, customerCareUL.firstChild);

    // Hide or show header on scroll down/up
    static_header
    && window.addEventListener('scroll', function(){
		var st = window.pageYOffset || document.documentElement.scrollTop;
    if (st >= lastScrollTop){
      // downscroll code
            if (st < 500 ) return;
          	static_header.classList.add('peeking-top');
   		} else {
      	// upscroll code
          	static_header.classList.remove('peeking-top');
   		}
   		lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
    });

    site_header.addEventListener('click', handle_site_header_click);

    function handle_site_header_click(e){
      if( !is_close_icon_init){
        search_bar_close = document.querySelector('.search-bar-close');
        // console.log("search bar close", search_bar_close);
        search_bar_close.addEventListener('click', collapse_search_bar);
        is_close_icon_init = true;
      }
      searchBarInput		= document.querySelector('.live-search-form-field');
      searchBar 			= document.querySelector('.live-search');
      site_header_main = document.querySelector('.site-header-main');
      if ( e.target.classList.contains('live-search-form-field')){
        search_bar_close.style.display = 'block';
        hamburgerMenuIcon.style.display = 'none';
        mobileLogo.style.display = 'none';
        phoneIcon.style.display = 'none';
        cartIcon.style.display = 'none';
        searchBarInput.style.maxWidth = "100%";
        searchBar.style.maxWidth = "100%";
        site_header_main.style.flexBasis = "100%";
        site_header_main.style.flexGrow = "1";
      } else {
        collapse_search_bar();
      }
    }
    
    function collapse_search_bar(){
      search_bar_close.style.display = 'none';
      hamburgerMenuIcon.style.display = 'block';
      mobileLogo.style.display = 'flex';
      phoneIcon.style.display = 'block';
      cartIcon.style.display = 'block';
      searchBarInput.style.maxWidth = "220px";
      searchBar.style.maxWidth = "220px";
      site_header_main.style.flexBasis = "70%";
      site_header_main.style.flexGrow = "unset";
    }
  }// end of if mql
});